export default {
  // 获取客户合同
  CUSTOMER_CONTRACT: '/sales/mto/contract/listMtoContractByPage',
  // 获取字典表中的产品枚举
  DATA_DICT: '/maindata/dictData/listDataDictByDataType',
  // 获取服务供方数据
  SERVICE_DATA: '/sales/mto/contract/listMtoContractByPage',
  // 获取线路名称数据
  ROUTE_NAME: '/maindata/route/listByPage',
  // 获取商品名称下拉
  GOODS_NAME: '/maindata/product/listProduct',
  // 通过商品名称湖区商品子类编码数据
  PRODUCT_DETAIL_CODE: '/maindata/productDetail/listProductDetail',
  // 订单保存
  ORDER_SAVE: '/order/mto/order/save',
  // 订单列表
  ORDER_LIST: '/order/mto/order/listOrderByPage',
  // 订单作废
  ORDER_INVALID: '/order/mto/order/invalidOrder',
  // 普通/集卡指令作废
  ORDINARY_INVALID: '/order/mto/ordinary/invalidOrdinaryTruckInstruct',
  // 铁路指令作废
  TRANSPORT_INVALID: '/order/mto/transport/invalidTransportInstruct',
  // 订单详情
  ORDER_DETAIL: '/order/mto/order/orderDetail',
  // 新建订单异常
  SAVE_ORDER_ABNORMAL: '/order/mto/order/exception/saveOrderException',
  // 订单异常详情
  ORDER_ABNORMAL_DETAIL: '/order/mto/order/exception/orderExceptionDetail',
  // 批量删除订单
  ORDER_PATCH_DELETE: '/order/mto/order/exception/deleteOrderException',
  // 普通公路数据导入
  HIGHWAY_IMPORT: '/order/mto/ordinary/importOrdinaryInstruct',
  // 普通铁路数据导入
  RAILWAY_IMPORT: '/order/mto/ordinary/importTruckContainerInstruct',
  // 批量下发普通或集卡服务
  // BATCH_ISSUED: '/order/mto/ordinary/clickOrdinaryTruckInstruct',
  BATCH_ISSUED: '/order/mto/ordinary/clickOrdinaryTruckInstruct',
  // 查看结算状态
  SETTLE_STATUS: '/financial/receivableSettlementExpense/querySettleStatus',
  // 获取运输指令详情
  INSTRUCT_DETAIL: '/order/mto/ordinary/getOrdinaryTruckInstructDetail',
  // 站点
  STATION_API: '/order/mto/station/listStationByPage',

  //新需求 单条下发
  SINGLE_ISSUE: '/order/mto/order/issueOrderInList',
  // 公路运输商品名称
  PRODUCT_PARENT_NAME: '/sales/mto/contract/getAllCargoList',
};
